import { bolt_color } from "./Power_WB_settings.js";

export function boltSection(
  g,
  H, //基础总高度
  H_groove, //凹槽深度
  Bd_in,
  Br_in,
  BPlate_in,
  Bd_out,
  Br_out,
  BPlate_out,
  Grout_thick,
  x, //定位x坐标:单边锚栓的居中的顶部
  y //定位y坐标
) {
  let width_BPlate = BPlate_out.value - BPlate_in.value;

  // 定义锚栓的group容器
  let boltSection = g
    .group()
    .addClass("boltSection")
    .translate(x, y)
    .stroke({ color: bolt_color })
    .fill("none");

  // 定义灌浆料
  boltSection.rect({
    x: -(width_BPlate + Grout_thick.value * 2) / 2,
    y: -Grout_thick.value,
    width: width_BPlate + Grout_thick.value * 2,
    height: Grout_thick.value,
  });
  // 定义上锚板
  boltSection.rect({
    x: -width_BPlate / 2,
    y: -(50 + Grout_thick.value),
    width: width_BPlate,
    height: 50,
  });
  boltSection.polyline([
    [width_BPlate / 2 - 35, -(50 + Grout_thick.value)],
    [width_BPlate / 2 - 35, -(140 + Grout_thick.value)],
    [30, -(140 + Grout_thick.value)],
    [23, -(143 + Grout_thick.value)],
    [20, -(150 + Grout_thick.value)],
    [20, -(350 + Grout_thick.value)],
    [10, -(350 + Grout_thick.value)],
    [5, -(330 + Grout_thick.value)],
    [-5, -(370 + Grout_thick.value)],
    [-10, -(350 + Grout_thick.value)],
    [-20, -(350 + Grout_thick.value)],
    [-20, -(150 + Grout_thick.value)],
    [-23, -(143 + Grout_thick.value)],
    [-30, -(140 + Grout_thick.value)],
    [-(width_BPlate / 2 - 35), -(140 + Grout_thick.value)],
    [-(width_BPlate / 2 - 35), -(50 + Grout_thick.value)],
  ]);
  // 定义下锚板
  boltSection.rect({
    x: -(width_BPlate - 100) / 2,
    y: H,
    width: (width_BPlate - 100),
    height: 50,
  });
  boltSection.rect({
    x: -32.5,
    y: H - 26,
    width: 65,
    height: 26,
  });
  boltSection.rect({
    x: -32.5,
    y: H + 50,
    width: 65,
    height: 26,
  });
  boltSection.rect({
    x: -18,
    y: H - 50,
    width: 36,
    height: H_groove + 50,
  });
  boltSection.rect({
    x: -width_BPlate / 2,
    y: H + H_groove,
    width: width_BPlate,
    height: 30,
  });
  boltSection
    .polyline([
      [-270, 100],
      [-130, 100],
      [-130, 0],
      [130, 0],
      [130, 100],
      [270, 100],
    ])
    .stroke({ color: "red", width: 60 })
    .move(-270, H + H_groove + 30);
  // 定义布置单根外圈锚栓
  let w_nuts = 80;
  let h_nuts = 30;
  let leftboltSection = boltSection.group();

  leftboltSection.rect({
    x: -w_nuts / 2 - (Br_out.value - Br_in.value) / 2,
    y: -(Grout_thick.value),
    width: w_nuts,
    height: h_nuts,
  });
  leftboltSection.rect({
    x: -w_nuts / 2 - (Br_out.value - Br_in.value) / 2,
    y: -(Grout_thick.value + 140) - h_nuts,
    width: w_nuts,
    height: h_nuts,
  });
  leftboltSection.rect({
    x: -w_nuts / 2 - (Br_out.value - Br_in.value) / 2,
    y: H - h_nuts,
    width: w_nuts,
    height: h_nuts,
  });
  leftboltSection.rect({
    x: -w_nuts / 2 - (Br_out.value - Br_in.value) / 2,
    y: H + 50 + h_nuts,
    width: w_nuts,
    height: h_nuts,
  });
  let y_bolt = Grout_thick.value + 50 + 90 + h_nuts + 50
  leftboltSection.rect({
    x: -(Bd_in.value + Bd_out.value) / 2 / 2 - (Br_out.value - Br_in.value) / 2,
    y: -y_bolt,
    width: (Bd_in.value + Bd_out.value) / 2,
    height: H + y_bolt + 50 + h_nuts + 50,
  });

  leftboltSection.line({
    x1: -(Br_out.value - Br_in.value) / 2,
    y1: -(y_bolt + 100),
    x2: -(Br_out.value - Br_in.value) / 2,
    y2: H + 300,
    "stroke-dasharray": "500 100 100 100",
    stroke: "red",
  });

  // 布置内圈锚栓
  boltSection.use(leftboltSection).translate(Br_out.value - Br_in.value);

  return boltSection;
}
